import React from 'react'
import * as styles from '@css/pricing_table.module.css'
import PropTypes from 'prop-types'
import { GradientPolygon } from '@icons'
import classNames from 'classnames'

const Plan = ({
  title,
  subTitle,
  price,
  period,
  points,
  style,
  mostPopular,
  footer,
}) => {
  return (
    <div
      className={classNames({
        [styles.plan]: true,
        [styles.hasMostPopular]: mostPopular,
      })}
      style={style}
    >
      {mostPopular && <h3 className={styles.mostPopular}>Most Popular</h3>}
      <h1 className={styles.title}>{title}</h1>
      <h3 className={styles.subTitle}>{subTitle}</h3>
      <div className="my-4">
        <span className={styles.price}>{price}</span>
        <span className={styles.period}>{period}</span>
      </div>
      {points && (
        <ul className={styles.pointsList}>
          {points.map(point => (
            <li key={point} className={styles.point}>
              <GradientPolygon className={styles.icon} />
              {point}
            </li>
          ))}
        </ul>
      )}
      <p className="text-white text-center font-xs">{footer}</p>
      <a
        href={process.env.REACT_APP_SIGNUP_LINK}
        className="bg-black shadow-sm text-white rounded-lg py-2 px-4 mt-4 hover:bg-opacity-60 transition duration-150"
      >
        Get AI generated amazing images!
      </a>
    </div>
  )
}

const PricingTable = ({ children }) => {
  return <div className="flex justify-center">{children}</div>
}

Plan.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  price: PropTypes.string,
  period: PropTypes.string,
  points: PropTypes.arrayOf(PropTypes.string),
  mostPopular: PropTypes.bool,
}

export { Plan, PricingTable }
